/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SasToken
 */
export interface SasToken {
    /**
     * 
     * @type {string}
     * @memberof SasToken
     */
    sasToken?: string;
    /**
     * 
     * @type {string}
     * @memberof SasToken
     */
    sasUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SasToken
     */
    folderName?: string;
}

/**
 * Check if a given object implements the SasToken interface.
 */
export function instanceOfSasToken(value: object): boolean {
    return true;
}

export function SasTokenFromJSON(json: any): SasToken {
    return SasTokenFromJSONTyped(json, false);
}

export function SasTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): SasToken {
    if (json == null) {
        return json;
    }
    return {
        
        'sasToken': json['sas_token'] == null ? undefined : json['sas_token'],
        'sasUrl': json['sas_url'] == null ? undefined : json['sas_url'],
        'folderName': json['folder_name'] == null ? undefined : json['folder_name'],
    };
}

export function SasTokenToJSON(value?: SasToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sas_token': value['sasToken'],
        'sas_url': value['sasUrl'],
        'folder_name': value['folderName'],
    };
}

